@if (model) {
<div class="p1">
    @if (model.data.store_name) {
    <p class="fw-bold">{{model.data.store_name}}</p>
    }
    @if (model.data.address) {
    <p>{{model.data.address}}</p>
    }
    @if (secondLine) {
    <p>{{secondLine}}</p>
    }
    @if (model?.data?.phone) {
    <p>{{model.data.phone}}</p>
    }

    @if (leadTime && model?.data?.type === 'metapack_collection') {
    <div class="m-t-2"
         [innerHTML]="leadTime"></div>
    } @else if (model.collectionDate) {
    <div class="m-t-2">
        {{'Get it by' | translate}}&nbsp;
        <span>{{model.collectionDate | date: 'EEE'}}</span>&nbsp;
        <span>{{model.collectionDate | date: 'd' | ordinal}}</span>&nbsp;
        <span>{{model.collectionDate | date: 'MMM'}}</span>
    </div>
    }
</div>
}
